import { useMemo } from 'react';

import { type RaAddressType } from '@modules/_shared/components/form/RaAddressInput';
import {
  type FormDefinitionType,
  RaForm,
} from '@modules/_shared/components/form/RaForm';
import { useLocale } from '@shared/hooks/locale';

type CreateLeadAddressStepProps = {
  data: RaAddressType;
  footerActionsComponent: React.ReactNode;
  onFormSubmitted: (data: Partial<RaAddressType>) => Promise<void>;
};

export const CreateLeadAddressStep = ({
  data,
  footerActionsComponent,
  onFormSubmitted,
}: CreateLeadAddressStepProps) => {
  const { countryCode } = useLocale();

  const formDefinition = useMemo<FormDefinitionType<RaAddressType>>(
    () =>
      ({ t }) =>
        [
          {
            type: 'address',
            name: 'address',
            label: t('Address'),
            gridProps: { xs: 12 },
            countryRestriction: countryCode,
          },
        ],
    [countryCode],
  );

  return (
    <RaForm
      formDefinition={formDefinition}
      defaultValues={data}
      onSubmit={onFormSubmitted}
      actionButtonsComponent={footerActionsComponent}
      contentScrollable
    />
  );
};

CreateLeadAddressStep.displayName = 'CreateLeadAddressStep';
